import {CustomerRoutes, Routes} from '@/config/routes';

export const getOrdersRoute = () => {
    return `${Routes.customer}/${CustomerRoutes.orders}`;
};

export const getOrderDetailRoute = (id: string) => {
    return CustomerRoutes.orderDetail(id);
};
